import React, { useEffect, useState } from 'react';
import logo from '../../Assets/logo.png';
import { ButtonWithoutIcon } from '../../constents/components';
import useRouteFunctions from '../../Hooks/Routes/useRouteFunctions';

const PopUp = () => {
    const { goToDashboard } = useRouteFunctions();
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    goToDashboard();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='fixed inset-0 flex items-center justify-center p-8 bg-popup-bg-color backdrop-blur-[2px] z-[--after-registration-popup]'>
            <div className='bg-white w-full md:w-4/5 lg:w-2/5 space-y-3 rounded-2xl flex flex-col items-center p-6 pt-12'>
                <img className='h-8' src={logo} alt="zepcruit-icon" />
                <h3 className='font-semibold text-2xl text-center'>Interview Submitted Successfully</h3>
                <p className='text-center text-[#7D7D7D] leading-relaxed'>
                    Your interview has been recorded successfully.
                    <br />
                    <span className='font-medium text-black'>Redirecting to dashboard in {countdown}s…</span>
                </p>
                <ButtonWithoutIcon onButtonClick={() => {}} text={`Please wait (${countdown}s)`} classNames='w-full p-2 mt-4' />
            </div>
        </div>
    );
};

export default PopUp;
